<template>
  <div :class="isColorType ? 'message_color message_flex':'message_flex'">
    <!-- 消息提示 -->
    <div class="message_main">
      <el-dropdown trigger="click" ref="messageDrop">
        <el-badge :is-dot="isdot" class="message_tips">
          <!-- <i class="el-icon-message-solid"></i> -->
        </el-badge>
        <el-dropdown-menu
          slot="dropdown"
          class="message_list"
          v-if="items.length"
        >
          <!-- 头部信息 -->
          <div class="message_item_tips">
            <span class="title">消息中心</span>
            <span class="checked_ready" @click="handleMarkread">
              <i class="el-icon-close"></i>
            </span>
          </div>
          <!-- 具体列表 -->
          <ul class="scroll_h">
            <li
              :class="[
                'message_item',
                'clearfix',
                { message_item_active: item.hidden },
              ]"
              v-for="(item, index) in items"
              :key="index"
            >
              <div class="left_message">
                <span class="dot" v-if="item.hidden"></span>
                <span :class="handleTypeStyle(item)">{{ item.type }}</span>
              </div>
              <div class="right_message">
                <span class="time">{{ item.createDate }}</span>
                <span class="info ellipsis">{{ item.content }}</span>
              </div>
            </li>
          </ul>
          <!-- 查看更多 -->
          <div class="message_item_more" @click="showMore">
            查看更多&gt;&gt;
          </div>
        </el-dropdown-menu>
        <el-dropdown-menu slot="dropdown" class="message_list" v-else>
          <!-- 没有数据的显示 -->
          <div class="message_no_item">暂时没有消息</div>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <el-dropdown
      size="small"
      trigger="click"
      @command="
        (command) => {
          handleCommand(null, command);
        }
      "
    >
      <div class="userinfo_main">
        <div class="admin_icon">
          <i class="el-icon-s-custom"></i>
        </div>
        <div class="admin_info">
          <span class="name" :title="userInfo.name">{{ userInfo.name }}</span>
          <span class="power" :title="userInfo.description">{{
            userInfo.description
          }}</span>
        </div>
      </div>

      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="changepwd">修改密码</el-dropdown-item>
        <el-dropdown-item command="logout">登 出</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { pageOptions } from '@/utils/config.js'
import { userCurrent } from '@/api/user'
export default {// 登录和消息模块
  name: 'MessageFlex',
  props: {
    isColorType: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isCollapse: false,
      userInfo: {
        createTime: '',
        description: '',
        email: '',
        id: null,
        name: '',
        nickname: '请登录',
        phone: '',
        sex: null,
        status: null,
        updateTime: '',
        userName: '',
        visitTime: null
      },
      items: [
        // {
        //   type: 1,
        //   content: "消息内容",
        //   time: "2019.04.05",
        //   hidden: true // 是否隐藏小红点
        // },
        // {
        //   type: 2,
        //   content: "消息内容",
        //   time: "2019.04.05",
        //   hidden: true // 是否隐藏小红点
        // },
        // {
        //   type: 3,
        //   content: "消息内容",
        //   time: "2019.04.05",
        //   hidden: true // 是否隐藏小红点
        // },
        // {
        //   type: 4,
        //   content: "消息内容",
        //   time: "2019.04.05",
        //   hidden: true // 是否隐藏小红点
        // },
        // {
        //   type: 3,
        //   content: "消息内容",
        //   time: "2019.04.05",
        //   hidden: false // 是否隐藏小红点
        // }
      ],
      listQuery: {
        q: {
          projectState: '0'
        },
        page: 1,
        pageSize: pageOptions.pageSize
      },
      isMessageShow: false,
      isdot: false // 是否显示小圆点
    }
  },
  created () {
    this.getUserInfo()
    this.items = []
    // this.getToDoList();
  },
  methods: {
    handleMarkread () {
      this.$refs.messageDrop.hide()
    },
    // 查看更多
    showMore () {
      this.$router.push({ name: 'messageList' })
      this.$refs.messageDrop.hide()
    },
    handleCommand (row, command) {
      switch (command) {
        case 'logout':
          this.logout()
          break
        case 'changepwd':
          this.$router.push('/change/pwd')
          break
      }
    },
    // 登出
    async logout () {
      let result = await this.$store.dispatch('logout')
      if (result.code === 0) {
        this.$router.push({
          path: '/login'
        })
        localStorage.removeItem('isCompanyId')

        this.$message({
          message: '登出成功',
          type: 'success'
        })
      }
    },
    async getUserInfo () {
      let result = await userCurrent()
      if (result.code === 0) {
        this.userInfo = Object.assign(this.userInfo, result.data)
        // this.createPicture(this.userInfo.nickname);
        localStorage.setItem('isCompanyId', this.userInfo.companyId)
        // console.log(this.userInfo)
        this.$store.commit('SET_USERINFO', this.userInfo)

        // 加密数据
  			let set = encodeURIComponent(JSON.stringify(this.userInfo))
        localStorage.setItem('SET_USERINFO', btoa(set))
      }
    },
    // 处理类型的类
    handleTypeStyle (value) {
      let className = ''
      let type = value.type.toString()
      switch (type) {
        case '1':
          className = 'type1_style'
          break
        case '2':
          className = 'type2_style'
          break
        case '3':
          className = 'type3_style'
          break
        case '4':
          className = 'type4_style'
          break
      }
      if (!value.hidden) {
        className = ''
      }
      return className
    }
  }
}
</script>

<style lang="scss" scoped>
$color_1: #409eff;
$type1: #7dcaff; // 项目
$type2: #50d9b7; // 合同
$type3: #7197f5; // 人员
$type4: #ffae7d; // 统计
$type5: #d3d3d3; // 默认

  // 消息提示
  .message_flex {
    display: flex;
    align-items: center;
  }
  .message_tips {
    font-size: 18px;
    color: #228BFF;
    padding: 0 5px;
    margin-right: 20px;
    cursor: pointer;
    transform: rotate(45deg);
  }
  .userinfo_main {
    display: flex;
    align-items: center;
    width: 105px;
    .admin_icon {
      flex-shrink: 0;
      width: 33px;
      height: 33px;
      background: #000;
      border-radius: 50%;
      line-height: 33px;
      text-align: center;
      font-size: 17px;
      color: #fff;
      margin-right: 12px;
    }
    .admin_info {
      flex-shrink: 0;
      font-size: 14px;
      display: flex;
      flex-direction: column;
      .power {
        color: #999;
        font-size: 12px;
        display: block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 80px;
      }
      .name {
        font-size: 14px;
        display: block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 80px;
      }
    }
  }

.message_list {
  width: 250px;
  background: #fff;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  font-size: 12px;
  padding: 0 4px;
  box-sizing: border-box;
  .message_item_tips {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 5px;
    padding: 16px 16px 5px;
    .checked_ready {
      // color: $color_1;
      cursor: pointer;
      font-size: 16px;
    }
    .title {
      font-size: 16px;
    }
  }
  .message_item {
    color: #999;
    padding: 10px 0;
    border-bottom: 1px solid #eeeeee;
    cursor: pointer;
    display: flex;
    align-items: center;
    .left_message {
      float: left;
      margin-right: 15px;
      position: relative;
      span {
        display: block;
        width: 40px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        color: #fff;
        border-radius: 50%;
        background: $type5;
        position: relative;
      }
      .type1_style {
        background: $type1;
      }
      .type2_style {
        background: $type2;
      }
      .type3_style {
        background: $type3;
      }
      .type4_style {
        background: $type4;
      }
      .dot {
        position: absolute;
        top: 2px;
        right: 2px;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background: red;
        z-index: 1;
      }
    }
    .right_message {
      float: left;
      display: flex;
      flex-direction: column;
      font-size: 13px;
      .time {
        color: #999;
      }
      .info {
        color: #333;
        display: block;
        width: 150px;
      }
    }
  }
  .message_item_active {
    color: #333;
  }
  .message_item_more {
    padding: 16px 0;
    text-align: center;
    color: #409eff;
    cursor: pointer;
  }
  .message_no_item {
    color: #999;
    padding: 15px;
  }
  .scroll_h {
    padding: 0 16px;
    max-height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
    /* 设置滚动条的样式 */
    &::-webkit-scrollbar {
      width: 2px;
      background: #ffffff;
    }
    /* 滚动条滑块 */
    &::-webkit-scrollbar-thumb {
      width: 2px;
      background: #d3d3d3;
      border-radius: 2px;
    }
  }
}
.message_color{
  .userinfo_main .admin_icon{
    background: #0061CC;
  }
  .userinfo_main .admin_info .power{
    color: #0057B7;
  }
  .userinfo_main .admin_info .name{
    color: #228BFF;
  }
}
</style>
